import React from 'react'
import { inputClass, labelClass } from './taskScheduleConstants'
import { planStepTechnicalName, type PlanToolStep } from '../utils/taskPlanDisplay'

type HotField = {
  key: string
  label: string
  placeholder?: string
  type?: 'text' | 'url'
}

const HOT_FIELDS_BY_TOOL: Record<string, HotField[]> = {
  read_public_google_sheet: [
    {
      key: 'url',
      label: 'Google Sheet URL',
      placeholder: 'https://docs.google.com/spreadsheets/...',
      type: 'url',
    },
  ],
  search_google_ads: [
    { key: 'customerId', label: 'Google Ads customer ID' },
    { key: 'customer_id', label: 'Google Ads customer ID' },
  ],
  update_google_ads_campaign: [
    { key: 'customerId', label: 'Google Ads customer ID' },
    { key: 'customer_id', label: 'Google Ads customer ID' },
    { key: 'campaignId', label: 'Campaign ID' },
    { key: 'campaign_id', label: 'Campaign ID' },
  ],
  list_google_ads_client_accounts: [
    { key: 'customerId', label: 'Google Ads customer ID' },
    { key: 'customer_id', label: 'Google Ads customer ID' },
  ],
}

function fieldsForStep(step: PlanToolStep): HotField[] {
  const name = planStepTechnicalName(step).toLowerCase()
  const defs = HOT_FIELDS_BY_TOOL[name] || []
  const params = step.tool_parameters && typeof step.tool_parameters === 'object' ? step.tool_parameters : {}
  return defs.filter((f) => {
    if (name === 'read_public_google_sheet' && f.key === 'url') return true
    return Object.prototype.hasOwnProperty.call(params, f.key) || params[f.key] != null
  })
}

type Props = {
  steps: PlanToolStep[]
  onChangeStepParam: (executionOrder: number, key: string, value: string) => void
}

/** Narrow merchant editors for high-traffic tool parameters. */
export default function HotParamEditors({ steps, onChangeStepParam }: Props) {
  const editable = steps
    .map((step, idx) => ({
      step,
      order: step.execution_order ?? idx + 1,
      fields: fieldsForStep(step),
    }))
    .filter((row) => row.fields.length > 0)

  if (editable.length === 0) return null

  return (
    <div className="tw-space-y-3">
      <p className="tw-m-0 tw-text-xs tw-font-medium tw-text-slate-600">Key settings</p>
      {editable.map(({ step, order, fields }) => {
        const params =
          step.tool_parameters && typeof step.tool_parameters === 'object' ? step.tool_parameters : {}
        return (
          <div
            key={`${planStepTechnicalName(step)}-${order}`}
            className="tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-p-3 tw-space-y-2"
          >
            <p className="tw-m-0 tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500">
              Step {order}
            </p>
            {fields.map((field) => (
              <div key={field.key}>
                <label className={labelClass} htmlFor={`hot-${order}-${field.key}`}>
                  {field.label}
                </label>
                <input
                  id={`hot-${order}-${field.key}`}
                  type={field.type || 'text'}
                  className={inputClass}
                  value={params[field.key] != null ? String(params[field.key]) : ''}
                  placeholder={field.placeholder}
                  onChange={(e) => onChangeStepParam(order, field.key, e.target.value)}
                />
              </div>
            ))}
          </div>
        )
      })}
    </div>
  )
}
